/**
 * Bipes sintéticos do composer de voz — "tem sons! ao iniciar ou parar"
 * (feedback do usuário, referência ChatGPT). Sintetizados via Web Audio
 * (`OscillatorNode`), sem depender de arquivo de áudio nenhum.
 *
 * `AudioContext` é injetável (parâmetro opcional) pro mesmo motivo de
 * `captura-de-voz.js`: o jsdom não implementa Web Audio, e um dublê no teste
 * evita depender do ambiente real.
 */

const DURACAO_SEGUNDOS = 0.09
const VOLUME = 0.08

const tocarBipe = (contexto, frequenciaHz) => {
  const oscilador = contexto.createOscillator()
  const ganho = contexto.createGain()
  oscilador.type = 'sine'
  oscilador.frequency.value = frequenciaHz
  ganho.gain.setValueAtTime(VOLUME, contexto.currentTime)
  ganho.gain.exponentialRampToValueAtTime(
    0.0001,
    contexto.currentTime + DURACAO_SEGUNDOS
  )
  oscilador.connect(ganho)
  ganho.connect(contexto.destination)
  oscilador.start()
  oscilador.stop(contexto.currentTime + DURACAO_SEGUNDOS)
}

// UM `AudioContext` para a sessão inteira, criado no primeiro bipe: cada
// `new AudioContext()` é um recurso do sistema que nunca era fechado, e o
// navegador limita quantos podem existir — depois do teto, bipe mudo.
let contextoCompartilhado = null

const ESTADO_SUSPENSO = 'suspended'

const obterContexto = () => {
  if (contextoCompartilhado) return contextoCompartilhado
  const Construtor = globalThis.AudioContext || globalThis.webkitAudioContext
  if (!Construtor) return null
  contextoCompartilhado = new Construtor()
  return contextoCompartilhado
}

// O contexto único pode ser suspenso pelo navegador entre um bipe e outro;
// sem retomar, o singleton tocaria em silêncio dali em diante.
const retomarSeSuspenso = (ctx) => {
  if (ctx.state !== ESTADO_SUSPENSO || !ctx.resume) return
  const retomada = ctx.resume()
  // Sem gesto do usuário (autoplay) ou contexto fechado, `resume()` REJEITA —
  // sem o catch, cada bipe deixava uma rejeição órfã; o bipe segue mesmo assim.
  if (retomada && retomada.catch) retomada.catch(() => {})
}

const tocar = (contexto, frequenciaHz) => {
  const ctx = contexto || obterContexto()
  if (!ctx) return
  retomarSeSuspenso(ctx)
  tocarBipe(ctx, frequenciaHz)
}

/** Bipe agudo-subindo — início de gravação. */
export const tocarSomDeInicio = (contexto) => tocar(contexto, 880)

/** Bipe curto-descendo — fim de gravação (parar ou cancelar). */
export const tocarSomDeFim = (contexto) => tocar(contexto, 660)
